import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=80837c16&scoped=true&"
import script from "./BaseCounter.vue?vue&type=script&lang=js&"
export * from "./BaseCounter.vue?vue&type=script&lang=js&"
import style0 from "./BaseCounter.vue?vue&type=style&index=0&id=80837c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80837c16",
  null
  
)

export default component.exports